export default __webpack_public_path__ + "static/media/orama.47b53693.png";